import React, { createContext, useContext, useState, useCallback } from 'react';

var TopBarContext = createContext({
  headerContent: null,
  setHeaderContent: function() {},
  pageSearchTerm: '',
  setPageSearchTerm: function() {},
  pageSearchHandler: null,
  setPageSearchHandler: function() {},
});

var TopBarProvider = function(props) {
  var state = useState(null);
  var headerContent = state[0];
  var setHeaderContent = state[1];

  var searchState = useState('');
  var pageSearchTerm = searchState[0];
  var setPageSearchTerm = searchState[1];

  var handlerRef = React.useRef(null);
  var setPageSearchHandler = useCallback(function(fn) {
    handlerRef.current = fn;
  }, []);

  var value = {
    headerContent: headerContent,
    setHeaderContent: setHeaderContent,
    pageSearchTerm: pageSearchTerm,
    setPageSearchTerm: setPageSearchTerm,
    pageSearchHandler: handlerRef,
    setPageSearchHandler: setPageSearchHandler,
  };

  return React.createElement(TopBarContext.Provider, { value: value }, props.children);
};

var useTopBar = function() {
  return useContext(TopBarContext);
};

export { TopBarProvider, useTopBar };
export default TopBarContext;
